import * as api from 'api';
import { toggleLoader } from "signals/base";
import { cities, countries, districts, provinces } from 'signals/region';
import { catch_error } from './base';
import { err_msg } from 'helper';

const get_countries = () => {
    toggleLoader(true)
    api.countries().then((response) => {
        let list_country = response.data.data.countries;
        countries.value = list_country;
    }).catch((err) => {
        /** Handle error , show modal or toast error */
        catch_error(err_msg(err));
    }).then(() => {
        toggleLoader(false)
    })
}

const get_provinces = (param) => {
    toggleLoader(true)
    api.provinces({
        params: {
            'country_code': param?.country_code
        }
    }).then((response) => {
        let list_provinces = response.data.data.provinces;
        provinces.value = list_provinces;
    }).catch((err) => {
        /** Handle error , show modal or toast error */
        catch_error(err_msg(err));
    }).then(() => {
        toggleLoader(false)
    })
}

const get_cities = (param) => {
    toggleLoader(true)
    api.cities({
        params: {
            'country_code': param?.country_code,
            'province_code': param?.province_code
        }
    }).then((response) => {
        const list_city = response.data.data.cities;
        cities.value = list_city;
    }).catch((err) => {
        /** Handle error , show modal or toast error */
        catch_error(err_msg(err));
    }).then(() => {
        toggleLoader(false)
    })
}

const get_districts = (param) => {
    toggleLoader(true)
    api.districts({
        params: {
            'country_code': param?.country_code,
            'province_code': param?.province_code,
            'city_code': param?.city_code,
        }
    }).then((response) => {
        let list_districts = response.data.data.districts;
        districts.value = list_districts;
    }).catch((err) => {
        /** Handle error , show modal or toast error */
        catch_error(err_msg(err));
    }).then(() => {
        toggleLoader(false)
    })
}

export {
    get_countries,
    get_provinces,
    get_cities,
    get_districts
}